<div class="leading-8 text-white text-sm text-center flex items-center root-event-btn-bg"
  [class]="mode==='one-line'?'h-8 justify-center':'h-16 pl-5 justify-start'">
  <mat-icon *ngIf="mode==='one-line'" class="mr-1 text-xl relative top-[-2px]">date_range</mat-icon>

  <ng-container *ngIf="mode==='one-line'">
    <ng-container *ngIf="item.eventTimes&&item.eventTimes.length<=1">
      <span class="text-center relative" *ngIf="item.timeOneLine"
        [class.one-line-time-long]="item.timeOneLine.length>37">{{item.timeOneLine}}</span>
    </ng-container>

    <ng-container *ngIf="item.eventTimes&&item.eventTimes.length>1">
      <span class="text-center relative">Multiple Dates Event - See Details</span>
    </ng-container>
  </ng-container>

  <!-- two-lines format for modern-block card, line 1 is date, line 2 is time -->
  <ng-container *ngIf="mode==='two-lines'">
    <div *ngIf="item.eventTimes&&item.eventTimes.length<=1">
      <div class="text-left relative bottom-[2px] text-base font-semibold" *ngIf="item.timeTwoLines">
        {{item.timeTwoLines.date}}</div>
      <div class="text-left relative top-[2px] text-xs" *ngIf="item.timeTwoLines">{{item.timeTwoLines.time}}</div>
      <div *ngIf="!item.timeTwoLines">{{item.name}}</div>
    </div>

    <ng-container *ngIf="item.eventTimes&&item.eventTimes.length>1">
      <span class="relative bottom-[2px] text-base font-semibold">Multiple Dates Event</span>
    </ng-container>
  </ng-container>

</div>